<template>
  <div>
    <app-banner title="Web Affiliate Badge Size" />
    <section class="content-wrapper">
      <div class="content">
        <p class="p3">
          Select a badge size for your website. You'll select imagery next. If
          you're creating a text link, or you want to use your own image,
          <a href="" @click.prevent="lastPage">continue here</a>.
        </p>
        <div class="flex">
          <input type="radio" id="one" value="120x60" v-model="selected" />
          <label for="one" class="one">
            120x60
          </label>
          <input type="radio" id="two" value="120x240" v-model="selected" />
          <label for="two" class="two">
            120x240
          </label>
          <input type="radio" id="three" value="300x250" v-model="selected" />
          <label for="three" class="three">
            300x250
          </label>
        </div>
        <button class="btn" @click="nextPage">Next</button>
        <p v-if="validated" class="alert">
          Select an option to continue
        </p>
        <a class="link" @click="prevPage">‹ Back</a>
      </div>
      <img
        :src="`${$assets}img-affiliate-3@1x.jpg`"
        :srcset="`${$assets}img-affiliate-3@2x.jpg 2x`"
        alt="Group mat class with Ultra-Fit Circle"
        class="wide photo"
      />
    </section>
  </div>
</template>

<script>
import AppBanner from "@/components/AppBanner.vue";

export default {
  name: "StepThree",

  components: {
    AppBanner
  },

  data() {
    return {
      selected: "",
      validated: ""
    };
  },

  methods: {
    nextPage() {
      if (this.selected) {
        this.validated = "";
        this.$bus.$emit("size", this.selected);
        this.$bus.$emit("textLink", false);
        this.$emit("clicked", "four");
      } else {
        this.validated = true;
      }
    },

    lastPage() {
      this.$bus.$emit("textLink", true);
      this.$emit("clicked", "five");
    },

    prevPage() {
      this.$emit("clicked", "two");
    }
  }
};
</script>

<style scoped>
.content-wrapper {
  display: flex;
  justify-content: center;
}

.content {
  padding: 50px 32px;
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
}

.p3 a {
  color: inherit;
  transition: 0.3s;
}

.p3 a:hover {
  color: gray;
}

label {
  display: inline-block;
  padding: 10px 20px;
  font-family: sans-serif, Arial;
  font-size: 16px;
  border: 1px solid var(--med-gray);
  border-radius: 0;
  transition: 0.3s;
  cursor: pointer;
  margin-right: 20px;
  margin-bottom: 20px;
  box-sizing: border-box;
}

input[type="radio"] {
  opacity: 0;
  position: fixed;
  width: 0;
}

input[type="radio"]:checked + label {
  border: 3px solid var(--green);
}

label:hover {
  background-color: var(--lt-gray);
}

.flex {
  display: flex wrap;
  margin: 30px 0;
  justify-content: center;
}

.one {
  width: 122px;
  height: 62px;
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.two {
  width: 122px;
  height: 242px;
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/60%;
}

.three {
  width: 100%;
  max-width: 302px;
  height: 252px;
  background: var(--white)
    url("http://s3.amazonaws.com/s3.pilates.com/web-affiliates/bb-gray-mark.svg")
    no-repeat center/40%;
}

.btn {
  background-color: var(--green);
  color: var(--white);
  border: none;
  cursor: pointer;
  font-weight: 500;
  font-size: 14rem;
  line-height: 1.143;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 165px;
  height: 30px;
  transition: 0.3s;
  margin-bottom: 20px;
}

.btn:hover {
  background-color: var(--dk-green);
}

.link {
  font-family: var(--roboto);
  font-size: 14rem;
  line-height: 1.143;
  font-weight: 500;
  color: var(--emerald);
  text-decoration: none;
  margin-top: auto;
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
}

.photo {
  width: 41%;
  max-width: 472px;
  object-fit: cover;
  flex: 0 0 auto;
  margin-left: 10px;
}

.alert {
  margin-bottom: 20px;
  font-size: 12rem;
}

@media (min-width: 768px) {
  .content {
    padding: 70px 0 70px 5%;
    width: 59%;
  }
}
</style>
